import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import { loadWithVxeTable } from '@/infrastructure/utils/load-vxetable';
import responseKeyNormalizerMapping from './mapping';
export default class PatentDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore todo
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
    }
    _getFolderAsync() {
        return loadWithVxeTable(() => import('./Folder.vue'));
    }
    get ListOperationServiceClass() {
        throw new TypeError('Patent ListOperationService Not implemented, TODO');
    }
    get FunctionBarServiceClass() {
        throw new TypeError('Patent FunctionBarService Not implemented, TODO');
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get basicInfo() {
        return { key: this.name, index: 0, label: `dataType.${this.name}`, entryRoute: { name: 'detailPatentRoot' } };
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(location) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(location),
            };
        }
        return {
            path: this.name,
            name: 'detailPatentRoot',
            redirect: `${self.PLUGIN_BASIC_PATH}/${this.name}/folders`,
            component: () => import('./PatentDetail.vue'),
            props: getDetailPageProps,
            children: [
                {
                    path: 'folders',
                    name: 'patentFolderPage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
                {
                    path: 'images',
                    name: 'patentImagePage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
                {
                    path: 'fullimgs',
                    name: 'patentFullimgPage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
                {
                    path: 'thumbs',
                    name: 'patentThumbPage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
                {
                    path: 'wordcloud',
                    name: 'patentWordCloudPage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
                {
                    path: 'fasttablelist',
                    name: 'patentLitePage',
                    component: self._getFolderAsync.bind(self),
                    props: getDetailPageProps,
                },
            ],
        };
    }
}
